module.exports = __webpack_public_path__ + "static/img/04.69108082.png";